import React, { useCallback, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { Button, Row } from 'reactstrap';

import ReactLoader from '../../../../../../components/Loader';

import { useGetAllServiceClassifications } from '../../../../hooks/useGetAllServiceClassification';
import ServiceClassificationModal from './ServiceClassificationModal';

import ServiceClassificationService from '../service';
import MatricesSLAService from '../../../service';
import ReasonService from '../../../../../reason/service';
import { matrixSLAServiceClassificationsTourSteps } from '../../../../utils/matrixSLATourSteps';
import Tour from 'reactour';

const ServiceClassificationList = ({ matrixSLAId }) => {
  const [modal, setModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [reasonsWithSubreasons, setReasonsWithSubreasons] = useState([]);
  const [matrixSLATourOpen, setMatrixSLATourOpen] = useState(false);

  const [matrixSLA, setMatrixSLA] = useState(null);
  const [
    quantityOfServiceClassifications,
    setQuantityOfServiceClassifications
  ] = useState([]);
  const [currentServiceClassification, setCurrentServiceClassification] =
    useState(null);
  const [currentImpactCriticality, setCurrentImpactCriticality] =
    useState(null);

  const {
    allServiceClassification,
    fetchServiceClassification,
    loadingClassifications
  } = useGetAllServiceClassifications(matrixSLAId);

  useEffect(() => {
    if (matrixSLAId) {
      setLoading(true);
      MatricesSLAService.getMatrixSLAById(matrixSLAId)
        .then((response) => {
          const data = response.data.content;
          setMatrixSLA(data);
          setLoading(false);
        })
        .catch((err) => {
          toast.error(
            err.response?.data?.message ||
              err.message ||
              'Erro ao buscar configuração da Matriz SLA'
          );
        });
    }
  }, [matrixSLAId]);

  useEffect(() => {
    if (matrixSLAId) {
      setLoading(true);
      ServiceClassificationService.getQuantityServiceClassificationByMatrixSLAId(
        matrixSLAId
      )
        .then((response) => {
          const data = response.data.content;
          setQuantityOfServiceClassifications(data);
          setLoading(false);
        })
        .catch((err) => {
          toast.error(
            err.response?.data?.message ||
              err.message ||
              'Erro ao buscar classificações de serviço da matriz SLA'
          );
        });
    }
  }, [matrixSLAId]);

  useEffect(() => {
    if (matrixSLA && matrixSLA.customerPortfolio) {
      ReasonService.getAllReasonSubreasonsByRecordType(
        matrixSLA?.customerPortfolio?.record_type_id
      )
        .then((response) => {
          const data = response.data.content;
          setReasonsWithSubreasons(data);
        })
        .catch((err) => {
          toast.error(
            err.response?.data?.message ||
              err.message ||
              'Erro ao buscar configuração da Matriz SLA'
          );
        });
    }
  }, [matrixSLA]);

  const toggle = useCallback(() => {
    setModal((prevModal) => !prevModal);
  }, []);

  const isClassificationFilled = (crit) => {
    const isFilled =
      crit &&
      crit.value &&
      allServiceClassification.some(
        (classification) =>
          classification.id_impacts_criticality === crit.value.id
      );
    return isFilled;
  };

  const organizeCurrentServiceClassification = useCallback(
    (impactCriticalityInfo) => {
      setCurrentImpactCriticality(impactCriticalityInfo);
      if (allServiceClassification && allServiceClassification.length > 0) {
        const serviceClassification = allServiceClassification.find(
          (serviceClassification) => {
            return (
              serviceClassification.id_impacts_criticality ===
              impactCriticalityInfo.crit.value.id
            );
          }
        );
        setCurrentServiceClassification(serviceClassification);
      }
      toggle();
    },
    [allServiceClassification, toggle]
  );

  const closeMatrixSLATour = () => setMatrixSLATourOpen(false);

  const openMatrixSLATour = () => setMatrixSLATourOpen(true);

  return (
    <>
      <>
        <Button
          className="float-right "
          type="button"
          outline
          color="info"
          onClick={openMatrixSLATour}
          title="Saiba mais sobre as configurações das Classificações de Serviço"
        >
          Saiba Mais
        </Button>
        <Tour
          steps={matrixSLAServiceClassificationsTourSteps}
          isOpen={matrixSLATourOpen}
          onRequestClose={closeMatrixSLATour}
        />
      </>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column'
        }}
      >
        {loadingClassifications && loading ? (
          <Row className="justify-content-md-center">
            <ReactLoader />
          </Row>
        ) : (
          matrixSLA && (
            <>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  marginBottom: '1rem'
                }}
              >
                <span
                  className="small tour-dt_matrix_sla_service_classifications_quantity"
                  style={{
                    margin: '0'
                  }}
                >
                  Quantidade de Classificações de Serviço: <br />
                  <strong className="tour-dt_matrix_sla_service_classifications_quantity_possible_values">
                    Possiveis:{' '}
                    {quantityOfServiceClassifications.quantityPossible || 0}{' '}
                    <br />
                  </strong>
                  <strong className="tour-dt_matrix_sla_service_classifications_quantity_current_values">
                    Cadastradas:{' '}
                    {quantityOfServiceClassifications.quantityCurrent || 0}{' '}
                    <br />
                  </strong>
                </span>
              </div>

              <div
                style={{
                  overflowX: 'auto'
                }}
              >
                <table>
                  <tbody>
                    {matrixSLA.impacts.map((impact, index) => {
                      return (
                        <tr key={index}>
                          {impact.criticality.map((crit, critIndex) => {
                            return (
                              <td
                                key={critIndex}
                                onClick={() => {
                                  const impactCriticalityInfo = {
                                    impact: impact,
                                    crit: crit
                                  };
                                  organizeCurrentServiceClassification(
                                    impactCriticalityInfo
                                  );
                                }}
                              >
                                <div>
                                  <Button
                                    color={
                                      isClassificationFilled(crit)
                                        ? 'success'
                                        : 'warning'
                                    }
                                    size="md"
                                    className="btn btn-primary tour1-dt_matrix_sla_service_classifications"
                                    style={{
                                      overflow: 'hidden',
                                      textOverflow: 'ellipsis',
                                      whiteSpace: 'nowrap',
                                      width: '14rem'
                                    }}
                                  >
                                    {`${impact.name} > ${crit.name}`}
                                  </Button>
                                </div>
                              </td>
                            );
                          })}
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </>
          )
        )}

        {modal && matrixSLA && currentImpactCriticality && (
          <ServiceClassificationModal
            matrixSLA={matrixSLA}
            modal={modal}
            toggle={toggle}
            currentImpactCriticality={currentImpactCriticality}
            currentServiceClassification={currentServiceClassification}
            reasonsWithSubreasons={reasonsWithSubreasons}
            fetchServiceClassification={fetchServiceClassification}
          />
        )}
      </div>
    </>
  );
};

export default ServiceClassificationList;
